import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Message } from '../../commons/message/message';
import { gaSubSectionAccess } from '../../../services/analitics';
import './index.scss';

export const NavigationSwitch = ({ activeCategory }) => {
  const { floorStatics, storeId, userLocale } = useSelector(
    (state) => state.config
  );
  const { floorKey, sectionKey } = useSelector((state) => state.location);
  const linkGroup = floorStatics[activeCategory].paths;

  return (
    <ul className={'navigation-category-links__container zds-heading-s'}>
      {linkGroup.map((group) => (
        <li key={group.location}>
          <Link
            to={`${group.sectionPath}${group.path}`}
            onClick={() => {
              const url = `${window.location.href.slice(0, -1)}${
                group.sectionPath
              }${group.path}`;
              gaSubSectionAccess(
                storeId,
                userLocale,
                floorKey,
                sectionKey,
                url
              );
            }}
          >
            <Message id={group.linkName} />
          </Link>
        </li>
      ))}
    </ul>
  );
};
